import { Link } from "react-router-dom";
import { Radio, ExternalLink, PlayCircle } from "lucide-react";

export const LIVE_STREAMS: Record<
  string,
  { name: string; youtube: string; accent: string; ring: string; btn: string }
> = {
  northwest: {
    name: "Pacific Northwest",
    youtube: "https://www.youtube.com/live/X83mPwE6rg8",
    accent: "from-violet-600 via-purple-600 to-fuchsia-600",
    ring: "ring-violet-300",
    btn: "bg-violet-700 hover:bg-violet-800",
  },
  southeast: {
    name: "Southeast",
    youtube: "https://www.youtube.com/live/Bj8nIzO_ams",
    accent: "from-teal-600 via-cyan-600 to-emerald-600",
    ring: "ring-teal-300",
    btn: "bg-teal-700 hover:bg-teal-800",
  },
};

interface Props {
  slug?: string | null;
  className?: string;
}

/** Live-stream banner shown on a region's conference / registration page. */
const LiveStreamCallout = ({ slug, className }: Props) => {
  const key = (slug || "").toLowerCase();
  const stream = LIVE_STREAMS[key];
  if (!stream) return null;

  return (
    <div className={`container mx-auto px-3 sm:px-4 ${className ?? "mb-4"}`}>
      <div
        className={`rounded-2xl bg-gradient-to-r ${stream.accent} p-[2px] shadow-xl ring-2 ${stream.ring}`}
      >
        <div className="rounded-[14px] bg-background/95 backdrop-blur px-4 py-3 flex flex-col sm:flex-row items-center gap-3">
          <div className="flex items-center gap-2 flex-1 min-w-0 text-center sm:text-left">
            <span className="relative inline-flex h-3 w-3 shrink-0">
              <span className="absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-70 animate-ping" />
              <span className="relative inline-flex h-3 w-3 rounded-full bg-red-600" />
            </span>
            <div className="min-w-0">
              <p className="text-sm sm:text-base font-extrabold text-foreground leading-tight">
                {stream.name} Conference 2026 — Live now
              </p>
              <p className="text-xs text-muted-foreground">
                Watch the sessions streaming live on YouTube.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Link
              to={`/conference/${key}/live`}
              className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold text-white shadow ${stream.btn}`}
            >
              <PlayCircle className="h-4 w-4" /> Watch live
            </Link>
            <a
              href={stream.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 rounded-full border border-border px-3 py-2 text-xs font-semibold text-foreground hover:bg-muted"
            >
              <Radio className="h-3.5 w-3.5" /> YouTube <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveStreamCallout;
